import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { SERVER_ERROR } from '../../constants/messages';
import AuthApi from '../../api/authApi';
import Api from '../../api/api';
import { ModalAlert, ModalHeader, ModalStatusIcon, switchModal } from '../popups/modal-parts';

class PasswordReset extends React.Component {
  constructor() {
    super();
    this.state = {
      errorMsgs: [],
      clientErrors: false,
      serverErrors: false,
      success: false,
      loading: false
    };
  }

  validateSubmission(data) {
    let errors = [];

    if (Api.hasEmptyFields(data)) {
      errors.push('Please fill in all fields');
    }

    if (data.password !== data.password_confirmation) {
      errors.push('The passwords you have entered did not match');
    }

    return errors;
  }

  handleSubmit(e) {
    let { location } = this.props;
    let query = queryString.parse(location.search);

    e.preventDefault();
    this.setState({ loading: true });
    const password = this.refs.password.value;
    const password_confirmation = this.refs.passwordConfirmation.value;
    var reset_token = 'empty';

    if (query.reset_token) {
      reset_token = query.reset_token;
    }

    const data = {
      password,
      password_confirmation
    };

    const errors = this.validateSubmission(data);
    data['reset_token'] = reset_token;

    if (errors.length) {
      return this.setState({ errorMsgs: errors, clientErrors: true, serverErrors: false, loading: false });
    }

    AuthApi.passwordReset(data, {
      onSuccess: () => {
        this.setState({
          serverErrors: false,
          clientErrors: false,
          success: true,
          loading: false,
          errorMsgs: []
        });
      },
      onError: () => {
        this.setState({
          serverErrors: true,
          clientErrors: false,
          success: false,
          errorMsgs: [],
          loading: false
        });
      }
    });
  }

  errors() {
    if (this.state.serverErrors) {
      return <ModalAlert>{SERVER_ERROR}</ModalAlert>;
    }

    if (!this.state.clientErrors) {
      return null;
    }

    const { errorMsgs } = this.state;

    return (
      <ModalAlert>
        {errorMsgs.length === 1 ? errorMsgs[0] : (
          <ul>
            {errorMsgs.map((error) => <li key={error}>{error}</li>)}
          </ul>
        )}
      </ModalAlert>
    );
  }

  successMsg() {
    return (
      <div className="modal-body is-centered">
        <ModalStatusIcon type="success" />
        <ModalHeader title="Password updated" sub="Your password has been reset. You can now sign in with your new password." />
        <div className="modal-actions">
          <button type="button" className="modal-btn modal-btn-primary" onClick={() => switchModal('login')}>
            Sign in
          </button>
        </div>
      </div>
    );
  }

  passwordForm() {
    const { loading } = this.state;

    return (
      <div className="modal-body">
        <ModalHeader title="Choose a new password" sub="Enter and confirm the new password for your account." />
        <form className="modal-form" onSubmit={this.handleSubmit.bind(this)}>
          {this.errors()}
          <div className="input-group">
            <label className="input-label" htmlFor="password">New Password</label>
            <input className="input-field" id="password" type="password" ref="password" name="password" autoComplete="new-password" required />
          </div>
          <div className="input-group">
            <label className="input-label" htmlFor="password-confirmation">Confirm New Password</label>
            <input className="input-field" id="password-confirmation" type="password" ref="passwordConfirmation" name="password-confirmation" autoComplete="new-password" required />
          </div>
          <button type="submit" className="modal-btn modal-btn-primary" disabled={loading}>
            {loading ? 'Saving…' : 'Reset password'}
          </button>
        </form>
      </div>
    );
  }

  render() {
    return this.state.success ? this.successMsg() : this.passwordForm();
  }
}

PasswordReset.propTypes = {
  location: PropTypes.object.isRequired
};

export default PasswordReset;
